import { Injectable } from '@angular/core';

export type LayoutMode = 'compact' | 'wide' | 'full';

@Injectable({
  providedIn: 'root'
})
export class AdminLayoutService {
  private mode: LayoutMode = 'compact';

  constructor() {
    this.applyLayoutClass();
  }

  public getLayout(): LayoutMode {
    return this.mode;
  }

  public applyLayoutClass() {
    const body = document.body;
    body.classList.remove('layout-compact', 'layout-wide');
    body.classList.add('layout-' + this.mode);
  }
}

